import { gql } from "@apollo/client";

export const GET_ALL_TIPO_PROFESIONALES_ESPECIALIDAD = gql`
query GetAllTipoProfesionalEspecialidad($idTipoProfesional: Int!) {
    allTipoProfesionalEspecialidad(idTipoProfesional: $idTipoProfesional){
            idTipoProfesionalEspecialidad,
            nombre
      }
}`;